import {match} from 'ts-pattern';

import {isNil, mergeAll} from 'ramda';

import {warehouseRoutes} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, logError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback, EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

interface ServiceCaseOrderFastTrackItemsDataGridProps {
  maximization?: EagGridMaximization;
  orderId: string;
}

const PREDEFINED_COLUMNS = ['fastTrackIssueNumber'] as const;

export function ServiceCaseOrderFastTrackItemsDataGrid(
  props: ServiceCaseOrderFastTrackItemsDataGridProps
) {
  const navigate = useNavigate();
  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {serviceOrderId: props.orderId}]);

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    const fastTrackIssueId = getColumnData<{id: string}>('fastTrackIssueNumber')?.value?.id;

    if (isNil(fastTrackIssueId)) {
      return logError('Fast track item id is not defined');
    }

    match(actionKey)
      .with('redirectDetail', () => {
        navigate(
          composePath(warehouseRoutes.fastTrackIssuesDetailOverview, {
            params: {
              id: fastTrackIssueId,
            },
            isSearchParamsPreserved: false,
          })
        );
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <DmsDataGrid
      maximization={props.maximization}
      autoHeight
      gridCode="service-case-order-fast-track-issue-items"
      actionCallback={actionCallback}
      queryModifier={queryModifier}
      predefinedColumns={PREDEFINED_COLUMNS}
      data-testid="fastTrackIssueItems"
    />
  );
}
